import { Consent } from 'models';
import { useMutation } from 'query';
import { acceptConsents } from '../../services';

export const useAcceptConsents = () => {
  return useMutation<Consent[], { consentIds: string[] }>(async ({ consentIds }) => {
    const response = await acceptConsents({ consent: { consent_ids: consentIds } });

    return response.data.map((consent) => new Consent(consent));
  });
};
